import { getResource } from "../api/http";

// Performance of every video over a period (sections videos, analytics or dashboard).
const query = (params = {}) => {
  const entries = Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== "");
  return entries.length ? `?${new URLSearchParams(entries).toString()}` : "";
};

/** `{ period, start, end, format, sort, q, page, fresh }`; rejects on failure. */
export const getVideoPerformance = (params) => getResource(`/api/admin/video-performance${query(params)}`, { rethrow: true });

/**
 * One video: views, plays, comments, likes and shares per day, drop-off. `period` is "30d" or
 * `{ period, start, end }`. Rejects on failure.
 */
export const getVideoPerformanceDetail = (id, period) =>
  getResource(`/api/admin/video-performance/${id}${query(typeof period === "string" ? { period } : period)}`, { rethrow: true });
